import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2"

import '../../styles/tarjetaContenedor.css'

/**
 * Objetos
 */
//Importación de las funcionalidades del objeto de tipo paciente
import { updatePatient } from '../../objects/patient';
//Importación de las funcionalidades del objeto de tipo logs
import { createLog } from '../../objects/logs';

/**
 * Utilerías
 */
//Imporatción de las funciones necesarias para la lógica
import { descrifrar } from '../../utils/functions';

/**
 * Componente que contiene los elementos relacionados al modal de información de paciente
 * @param {Object} param0 Recibe los objetos necesarios para mostrar la información del paciente
 * @returns Component Devuelve el componente con los elementos requeridos
 */
const PacienteModal = ({paciente,telefonoIsVisible, isRecuperacion,
  setIsVisible,tieneContactos,pacienteContactos,name,isEspecial,isRecuperacionOrigen,pacienteUnidadHospitalariaName}) => {

  //Estado que almacena la fecha de nacimiento de un paciente
  const [pacienteFechaNacimiento,setPacienteFechaNacimiento] = useState("")
  
  useEffect(()=>{
    if(paciente){
      if(paciente.birthdate){
        if(paciente.birthdate.toUpperCase() !== "No Disponible".toUpperCase()){
            let date = new Date(paciente.birthdate)
            // let hoy = new Date()
            // console.log(hoy.getFullYear()-date.getFullYear() + " años de edad")
            //setPacienteFechaNacimiento(paciente.birthdate.split(' ')[0])
            setPacienteFechaNacimiento(date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear())
        }
        else{
            setPacienteFechaNacimiento(paciente.birthdate)
        }
      }
      else{
          setPacienteFechaNacimiento("No Disponible")
      }
    }else{
      setPacienteFechaNacimiento("No Disponible")
    }
  },[paciente])
  
  /**
   * Función que cambia el estado del modal a oculto
   */
  const closeModal = () => {
    document.getElementById('modal').style.display='none'
    setIsVisible(false)
  } 
  
  /**
 * Función que atrapa el evento click de cancelar y dispara el cierre del modal
 * @returns Devuelve el estado del objeto
 */
const handleCancelarClick = () => (event) => {
  event.preventDefault()
  closeModal()
}

/**
* Función que atrapa el evento click de caso especial y dispara la actualización del paciente
* @param {Object} paciente Recibe la información del paciente al que se desea pasar a caso especial
* @returns Devuelve el estado del objeto
*/
const handleCasoEspecialClick = (paciente) => (event) => {
  event.preventDefault()
  let modalBody = ""
  modalBody += "<h2 class=info_itemconfirmTitle>Favor de ingresar el número de atención del paciente:</h2>"
  modalBody += "<h2 class=info_itemconfirm>"+paciente.NumeroDePaciente + " - " +paciente.patientname+"</h2>"
  modalBody += "<input id=chckIsInOperacion type=checkbox value=1>"

  if(isRecuperacion){
    modalBody += "<label for=chckIsInOperacion>¿El paciente continúa en control de recuperación?</label>"
  }
  else{
    if(isEspecial){
      if(isRecuperacionOrigen){
        modalBody += "<label for=chckIsInOperacion>¿El paciente continúa en control de recuperación?</label>"
      }
      else{
        modalBody += "<label for=chckIsInOperacion>¿El paciente continúa en control de quirófano?</label>"
      }
    }
    else{
      modalBody += "<label for=chckIsInOperacion>¿El paciente continúa en control de quirófano?</label>"
    }
  }
  Swal.fire({
    html:modalBody,
    //title: "Favor de ingresar el número de atención del paciente:",
    text: paciente.NumeroDePaciente + " - " +paciente.patientname,
    input: "text",
    showCancelButton: true,
    confirmButtonText: "Guardar",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#04afaa",
    allowOutsideClick:false,
    customClass: 'swal-confirm',
    preConfirm: (text) => {
      return new Promise((resolve) => {
        if (!text) {
          Swal.showValidationMessage('No ha proporcionado el número de atención')
        }
        else{
          if(text !== paciente.NumeroDePaciente){
            Swal.showValidationMessage('El número de atención proporcionado no coicide con el del paciente seleccionado')
          }
        }
        resolve()
      })
    },
  })
  .then(resultado => {
    if (resultado.value) {
      let estatus = document.getElementById('chckIsInOperacion').checked
        if(resultado.value === paciente.NumeroDePaciente){
          Swal.fire({
            title: "¿Desea reportar el cambio de estado del paciente " + paciente.NumeroDePaciente + " " +paciente.patientname + " a Caso Especial?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonColor: '#04afaa',
            confirmButtonText: 'Aceptar',
            denyButtonText: `Cancelar`,
            cancelButtonText:`Cancelar`,
          }).then((result) => {
            if (result.isConfirmed) {
              console.log(paciente)
              console.log(estatus)
              reportarCambioEstadoPaciente(paciente,"Especial",estatus)
            }
          })
        }
        else{
          Swal.fire({
            icon: 'warning',
            title: 'Error',
            text: "El número de atención proporcionado no coicide con el del paciente seleccionado",
          })
        }
    }
  });
}

/**
* Función que atrapa el evento click de caso especial y dispara la actualización del paciente
* @param {Object} paciente Recibe la información del paciente al que se desea pasar a caso especial
* @returns Devuelve el estado del objeto
*/
const handleCancelarCirugiaClick = (paciente) => (event) => {
  event.preventDefault()
  let modalBody = ""
  modalBody += "<h2 class=info_itemconfirmTitle>Favor de ingresar el número de atención del paciente:</h2>"
  modalBody += "<h2 class=info_itemconfirm>"+paciente.NumeroDePaciente + " - " +paciente.patientname+"</h2>"

  Swal.fire({
    html:modalBody,
    //title: "Favor de ingresar el número de atención del paciente:",
    text: paciente.NumeroDePaciente + " - " +paciente.patientname,
    input: "text",
    showCancelButton: true,
    confirmButtonText: "Guardar",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#04afaa",
    allowOutsideClick:false,
    customClass: 'swal-confirm',
    preConfirm: (text) => {
      return new Promise((resolve) => {
        if (!text) {
          Swal.showValidationMessage('No ha proporcionado el número de atención')
        }
        else{
          if(text !== paciente.NumeroDePaciente){
            Swal.showValidationMessage('El número de atención proporcionado no coicide con el del paciente seleccionado')
          }
        }
        resolve()
      })
    },
  })
  .then(resultado => {
    if (resultado.value) {
        if(resultado.value === paciente.NumeroDePaciente){
          Swal.fire({
            title: "¿Desea cancelar la cirugía del paciente " + paciente.NumeroDePaciente + " " +paciente.patientname + "?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonColor: '#04afaa',
            confirmButtonText: 'Aceptar',
            denyButtonText: `Cancelar`,
            cancelButtonText:`Cancelar`,
          }).then((result) => {
            if (result.isConfirmed) {
              reportarCancelarCirugia(paciente)
            }
          })
        }
        else{
          Swal.fire({
            icon: 'warning',
            title: 'Error',
            text: "El número de atención proporcionado no coicide con el del paciente seleccionado",
          })
        }
    }
  });
}

/**
* Función que atrapa el evento click de dar salida y dispara la salida del paciente
* @param {Object} paciente Recibe la información del paciente al que se desea dar salida
* @returns Devuele el estado del objeto
*/
const handleSalidaClick = (paciente) => (event) => {
  event.preventDefault()
  Swal.fire({
    title: "¿Desea reportar el cambio de estado del paciente " + paciente.NumeroDePaciente + " " +paciente.patientname + " a Cuarto?",
    showDenyButton: false,
    showCancelButton: true,
    confirmButtonColor: '#04afaa',
    confirmButtonText: 'Aceptar',
    denyButtonText: `Cancelar`,
    cancelButtonText:`Cancelar`,
  }).then((result) => {
    if (result.isConfirmed) {
      reportarCambioEstadoPaciente(paciente,"Salida",false)
    }
  })
}

/**
* Función que atrapa el evento click de dar salida a recuperación y dispara la actualización del paciente
* @param {Object} paciente Recibe la información del paciente al que se desea pasar a recuperación
* @returns Devuelve el estado del objeto
*/
const handleRecuperacionClick = (paciente) => (event) => {
  event.preventDefault()
  Swal.fire({
    title: "¿Desea reportar el cambio de estado del paciente " + paciente.NumeroDePaciente + " " +paciente.patientname + " a Recuperación?",
    showDenyButton: false,
    showCancelButton: true,
    confirmButtonColor: '#04afaa',
    confirmButtonText: 'Aceptar',
    cancelButtonText:`Cancelar`,
    denyButtonText: `Cancelar`,
  }).then((result) => {
    if (result.isConfirmed) {
      reportarCambioEstadoPaciente(paciente,"Recuperacion",true)
    }
  })
}

const handleQuirofanoClick = (paciente) => (event) => {
  event.preventDefault()
  Swal.fire({
    title: "¿Desea reportar el cambio de estado del paciente " + paciente.NumeroDePaciente + " " +paciente.patientname + " a Quirófano?",
    showDenyButton: false,
    showCancelButton: true,
    confirmButtonColor: '#04afaa',
    confirmButtonText: 'Aceptar',
    denyButtonText: `Cancelar`,
    cancelButtonText:`Cancelar`,
  }).then((result) => {
    if (result.isConfirmed) {
      reportarCambioEstadoPaciente(paciente,"Quirofano",true)
    }
  })
}

/**
* Función que atrapa el evento click de dar salida y dispara la salida administrativa del paciente
* @param {Object} paciente Recibe la información del paciente al que se desea dar salida
* @returns Devuele el estado del objeto
*/
const handleAltaClick = (paciente) => (event) => {
  event.preventDefault()
  Swal.fire({
    title: "¿Desea reportar el cambio de estado del paciente " + paciente.NumeroDePaciente + " " +paciente.patientname + " en Ambulatorio Alta?",
    showDenyButton: false,
    showCancelButton: true,
    confirmButtonColor: '#04afaa',
    confirmButtonText: 'Aceptar',
    denyButtonText: `Cancelar`,
    cancelButtonText:`Cancelar`,
  }).then((result) => {
    if (result.isConfirmed) {
      reportarCambioEstadoPaciente(paciente,"Ambulatorio Alta",false)
    }
  })
}


/**
* Función que reporta cuando se ha presentado un cambio de estado en un paciente
* @param {Object} paciente Recibe la información del paciente
* @param {String} estado Recibe el estado al que cambio el paciente
*/
const reportarCambioEstadoPaciente = async (paciente,estado,IsInOperacion) => {
  let mensaje = ""
  switch(estado){
    case "Especial":
      mensaje = "Se ha reportado paciente con caso especial de manera exitosa"
      break
    case "Recuperacion":
      mensaje = "Salida a sala de recuperación reportada de manera exitosa"
      break
    case "Salida":
      mensaje = "Salida a cuarto reportada de manera exitosa"
      break
    case "Quirofano":
      mensaje = "Regreso a quirófano reportado de manera exitosa"
      break
    case "Ambulatorio Alta":
      mensaje = "Ambulatorio Alta reportada de manera exitosa"
      break
    default:
      mensaje = "Salida a sala de recuperación reportada de manera exitosa"
      break
  }

  let ultimoEstatus = "Quirófano"
  if(isRecuperacion){
    ultimoEstatus = "Recuperación"
  }
  else{
    if(isEspecial){
      ultimoEstatus = "Especial"
    }
  }

  if(estado === "Quirofano"){
    ultimoEstatus = "Recuperación"
  }

  solicitarCambioEstado()
  async function solicitarCambioEstado(){
    closeModal()
    const response = await updatePatient(paciente,estado,IsInOperacion,ultimoEstatus)
    if(response === "success"){
      let date = new Date()
      createLog(paciente,
        sessionStorage.getItem('id'),
        descrifrar(name).toString(),
        "Report status to " + estado,
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
        date.getHours()+":"+date.getMinutes()+":"+date.getSeconds()+":"+date.getMilliseconds(),
        ultimoEstatus,
        IsInOperacion
      )
      Swal.fire({
        icon: 'success',
        title: 'Momento de quirófano',
        text: mensaje,
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#04afaa",
      })
    }
    else{
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: response,
      })
    }
  }
}

const reportarCancelarCirugia = async (paciente) => {
  let mensaje = "Se ha cancelado la cirugía de manera exitosa"

  let ultimoEstatus = "Quirófano"
  solicitarCambioEstado()
  async function solicitarCambioEstado(){
    closeModal()
    const response = await updatePatient(paciente,"Cancelación",false,ultimoEstatus)
    if(response === "success"){
      let date = new Date()
      createLog(paciente,
        sessionStorage.getItem('id'),
        descrifrar(name).toString(),
        "Report status to Cancelación",
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
        date.getHours()+":"+date.getMinutes()+":"+date.getSeconds()+":"+date.getMilliseconds(),
        ultimoEstatus
      )
      Swal.fire({
        icon: 'success',
        title: 'Momento de quirófano',
        text: mensaje,
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#04afaa",
      })
    }
    else{
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: response,
      })
    }
  }
}

const handleContactosClick = () => (event) => {
  event.preventDefault()
  let contactos = ""
  contactos += "<h2 class=modalPacienteTitle>Contactos "+paciente.NumeroDePaciente+"</h2>"
  contactos += "<h1 class='info_itemblog'>"+paciente.patientname+"</h1>"
  contactos += "<h1 class='info_itemblog'>"+paciente.NumeroTelefono+"</h1>"
  for(let i=0; i< pacienteContactos.length;i++){
      contactos += "<h1 class='info_itemblog'>"+pacienteContactos[i]+"</h1>"
  }
  Swal.fire({
      html:
        contactos,
      showCloseButton: true,
      showConfirmButton:false,
      customClass: 'swal-height'
    })
}
  
  return (
    <div id='modal' className='modal'>
      <div className='modal-content'>
          <span className='closeBtn' onClick={handleCancelarClick()}>X</span>
          <br/>
          <form id="msform">
            {
              paciente?<>
              <h2 className="modalPacienteTitle">{paciente.NumeroDePaciente.toUpperCase()}</h2>
              <h2 className="modalInfo">{pacienteUnidadHospitalariaName}</h2>
              <h2 className="modalInfo">{paciente.patientname}</h2>
              <h2 className="modalInfo">Fec. Nac.: {pacienteFechaNacimiento}</h2></>
              
              :null
            }
              {
                telefonoIsVisible && paciente  ? 
                  tieneContactos ? <h2 className="modalInfo">{paciente.NumeroTelefono} <span className='tieneContactos' onClick={handleContactosClick()}>+</span></h2>
                  : <h2 className="modalInfo">{paciente.NumeroTelefono}</h2>
                : null
              }
              {
              !isRecuperacion ?
                !isEspecial ?
                  <>
                    <h2 className="modalInfo">{"En quirófano"}</h2>
                    <input type="button" name="previous" className="previous recuperacion-button" value="Paciente en Sala de Recuperación" onClick={handleRecuperacionClick(paciente)}/>
                    <input type="button" name="previous" className="previous salida-button" value="Paciente en Cuarto" onClick={handleSalidaClick(paciente)}/>
                  </>
                :
                  <>
                    {
                      !isRecuperacionOrigen ? 
                        <>
                          <h2 className="modalInfo">{"Con caso especial(Quirófano)"}</h2>
                          <input type="button" name="previous" className="previous recuperacion-button" value="Paciente en Sala de Recuperación" onClick={handleRecuperacionClick(paciente)}/>
                        </>
                      : 
                        <>
                          <h2 className="modalInfo">{"Con caso especial(Recuperación)"}</h2>
                          <input type="button" name="previous" className="previous recuperacion-button" value="Paciente en Quirófano" onClick={handleQuirofanoClick(paciente)}/>
                        </>
                    }
                    <input type="button" name="previous" className="previous salida-button" value="Paciente en Cuarto" onClick={handleSalidaClick(paciente)}/>
                  </>
              : 
                  <>
                    <h2 className="modalInfo">{"En recuperación"}</h2>
                    <input type="button" name="previous" className="previous recuperacion-button" value="Paciente en Quirófano" onClick={handleQuirofanoClick(paciente)}/>
                    <input type="button" name="previous" className="previous salida-button" value="Paciente en Cuarto" onClick={handleSalidaClick(paciente)}/>
                  </>
              }
              <input type="submit" name="submit" className="submit especial-button" value="Paciente con Caso Especial" onClick={handleCasoEspecialClick(paciente)}/>
              <input type="submit" name="submit" className="submit alta-button" value="Paciente Ambulatorio Alta" onClick={handleAltaClick(paciente)}/>
              {
                !isRecuperacion && !isEspecial ? <span className='cancelar-cirugia'onClick={handleCancelarCirugiaClick(paciente)}>Cancelar cirugía</span>
                : null
              }
              {/* <input type="submit" name="submit" className="submit cancel-button" value="Cerrar Pantalla" onClick={handleCancelarClick()}/> */}
          </form>
      </div>
  </div>
    )
}

export default PacienteModal